const ChartBars = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4363 16.8751H16.5613C16.3126 16.8751 16.0742 16.7763 15.8984 16.6005C15.7226 16.4247 15.6238 16.1862 15.6238 15.9376V4.06256C15.6238 3.81392 15.7226 3.57546 15.8984 3.39965C16.0742 3.22383 16.3126 3.12506 16.5613 3.12506H18.4363C18.6849 3.12506 18.9234 3.22383 19.0992 3.39965C19.275 3.57546 19.3738 3.81392 19.3738 4.06256V15.9376C19.3738 16.1862 19.275 16.4247 19.0992 16.6005C18.9234 16.7763 18.6849 16.8751 18.4363 16.8751Z"
      fill="black"
    />
    <path
      d="M13.4377 16.8752H11.5627C11.3141 16.8752 11.0756 16.7765 10.8998 16.6007C10.724 16.4248 10.6252 16.1864 10.6252 15.9377V7.18774C10.6252 6.9391 10.724 6.70065 10.8998 6.52483C11.0756 6.34902 11.3141 6.25024 11.5627 6.25024H13.4377C13.6864 6.25024 13.9248 6.34902 14.1007 6.52483C14.2765 6.70065 14.3752 6.9391 14.3752 7.18774V15.9377C14.3752 16.1864 14.2765 16.4248 14.1007 16.6007C13.9248 16.7765 13.6864 16.8752 13.4377 16.8752Z"
      fill="black"
    />
    <path
      d="M8.43815 16.8763H6.56288C6.3142 16.8763 6.07571 16.7775 5.89987 16.6017C5.72403 16.4258 5.62524 16.1873 5.62524 15.9386V9.68776C5.62524 9.43908 5.72403 9.20059 5.89987 9.02475C6.07571 8.84891 6.3142 8.75012 6.56288 8.75012H8.43815C8.68682 8.75012 8.92531 8.84891 9.10115 9.02475C9.27699 9.20059 9.37578 9.43908 9.37578 9.68776V15.9386C9.37578 16.1873 9.27699 16.4258 9.10115 16.6017C8.92531 16.7775 8.68682 16.8763 8.43815 16.8763Z"
      fill="black"
    />
    <path
      d="M3.43766 16.8763H1.56239C1.31371 16.8763 1.07522 16.7775 0.899382 16.6017C0.723542 16.4258 0.624756 16.1873 0.624756 15.9387V12.1881C0.624756 11.9394 0.723542 11.701 0.899382 11.5251C1.07522 11.3493 1.31371 11.2505 1.56239 11.2505H3.43766C3.68633 11.2505 3.92482 11.3493 4.10066 11.5251C4.2765 11.701 4.37529 11.9394 4.37529 12.1881V15.9387C4.37529 16.1873 4.2765 16.4258 4.10066 16.6017C3.92482 16.7775 3.68633 16.8763 3.43766 16.8763Z"
      fill="black"
    />
  </svg>
);

export default ChartBars;
